import c from "./consts";

export default {
  [c.HOURLY_FORECAST]: [],
  [c.MODEL_FORECAST]: [],
  [c.SYNOPTIC_FORECAST]: [],
  [c.LOCATIONS]: [],
  [c.SELECTED_LOCATION]: null,
  [c.AI_FORECAST]: [],
  [c.MIRINE_FORECAST]: [],
  [c.RADAR_SADG]: [],
  [c.RADAR_DALN]: [],
  [c.WARNING]: [],
  [c.AMK_DATA]: [],
  [c.GRAPH_DATA]: [],
  [c.LOCATION_COORDINATES]: [],
  [c.GRIB_CLOUD]: [],
  [c.AVAILABLE_MODELS]: [],
  [c.SELECTED_MODEL]: null,
  [c.IS_LOADING]: false,
  [c.SYN_MAPS]: {
    updated_at: null,
    run_date: null,
    run_hour: null,
    items: [],
  },
  [c.SELECTED_WAVE_LOCATION]: null,
  [c.WAVE_LOCATIONS]: [],
  [c.WAVE_FORECAST]: [],
  [c.TYPHOON_GEOJSON]: []
};